//import "./Chat.css"
import StringToDateTime from "../../util/StringToDateTime";
import { ReactComponent as File_NoType_Icon } from "../../files/system/File_NoType_Icon.svg";
import { ReactComponent as File_Excel_Icon } from "../../files/system/File_Excel_Icon.svg";
import { ReactComponent as File_World_Icon } from "../../files/system/File_World_Icon.svg";
import { ReactComponent as File_Pdf_Icon } from "../../files/system/File_Pdf_Icon.svg";
import { ReactComponent as File_Video_Icon } from "../../files/system/File_Video_Icon.svg";
import { ReactComponent as File_Photo_Icon } from "../../files/system/File_Photo_Icon.svg";
import { ReactComponent as File_Music_Icon } from "../../files/system/File_Music_Icon.svg";
import { ReactComponent as File_Archive_Icon } from "../../files/system/File_Archive_Icon.svg";

function Message({ message }) {
    /*
    messages:[{
      id --ИД сообщения
    , name --Имя пользователя
    , text --Текст сообщение
    , avatar
    , myMessage --Мое сообщение
    , date - Дата сообщения
    , files - файлы
    }]

    files :[{
         idFile - ИД файла
        ,name - Название файла
        ,idType - Тип файла 0	Не определено
                            1	Видео
                            2	Фото
                            3	Музыка
                            4	Excel
                            5	Word
                            6	Pdf
                            7	Архив
    }]
    */
    return (
        <>
            <div className={message.myMessage === true ? 'message_item_my' : 'message_item_other'}>
                {
                    <div className="message_item">
                        {message.text}
                        {message.files !== null &&
                            message.files.map(f => (
                                <div key={f.idFile} className="message_file_row">
                                    <div>
                                        {f.idType === 0 && (<File_NoType_Icon className="message_file_row_icon" />)}
                                        {f.idType === 1 && (<File_Video_Icon className="message_file_row_icon" />)}
                                        {f.idType === 2 && (<File_Photo_Icon className="message_file_row_icon" />)}
                                        {f.idType === 3 && (<File_Music_Icon className="message_file_row_icon" />)}
                                        {f.idType === 4 && (<File_Excel_Icon className="message_file_row_icon" />)}
                                        {f.idType === 5 && (<File_World_Icon className="message_file_row_icon" />)}
                                        {f.idType === 6 && (<File_Pdf_Icon className="message_file_row_icon" />)}
                                        {f.idType === 7 && (<File_Archive_Icon className="message_file_row_icon" />)}
                                    </div>
                                    <a href={'https://api.ticket.biz-office.ru/ticket/fileDownload?ID_File=' + f.idFile} className="message_file_row_text">{f.name}</a>
                                </div>
                            ))
                        }
                        <div className="date">{message.myMessage === true ? StringToDateTime(message.date) : <> support {StringToDateTime(message.date)}</>}</div>
                    </div>
                }
            </div>
        </>
    )
}

export default Message;